// ---------------------------------------------------------------------------
// index.ts — theme client entry. Bundled by scripts/build-frontend.ts →
// template/static/js/main.js (loaded deferred from base.html).
//
// Each behaviour lives in its own module exporting an `init()` function.
// Register it here; the registry runs every module on DOMContentLoaded and
// isolates failures so one broken module can't take down the rest.
// ---------------------------------------------------------------------------

import { initImageLoading } from './modules/imageLoading';
import { initDates } from './modules/dates';
import { initNav } from './modules/nav';
import { initLogo } from './modules/logo';
import { initCarousel } from './modules/carousel';
import { initGradient } from './modules/gradient';
import { initTabs } from './modules/tabs';
import { initContactForm } from './modules/contactForm';
import { initAccordion } from './modules/accordion';
import { initFaqSections } from './modules/faqSections';
import { initCheckout } from './modules/checkout';
import { initSignupModal } from './modules/signupModal';
import { initConsent } from './modules/consent';
import { initNewsletter } from './modules/newsletter';

type Module = { name: string; init: () => void };

const modules: Module[] = [
	{ name: 'imageLoading', init: initImageLoading },
	{ name: 'dates', init: initDates },
	{ name: 'nav', init: initNav },
	{ name: 'logo', init: initLogo },
	{ name: 'carousel', init: initCarousel },
	{ name: 'gradient', init: initGradient },
	{ name: 'tabs', init: initTabs },
	{ name: 'contactForm', init: initContactForm },
	{ name: 'accordion', init: initAccordion },
	{ name: 'faqSections', init: initFaqSections },
	{ name: 'checkout', init: initCheckout },
	{ name: 'signupModal', init: initSignupModal },
	{ name: 'consent', init: initConsent },
	{ name: 'newsletter', init: initNewsletter },
];

const run = (): void => {
	for (const mod of modules) {
		try {
			mod.init();
		} catch (err) {
			console.error(`[theme] module "${mod.name}" failed:`, err);
		}
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', run);
} else {
	run();
}
